import { Modal, ModalFooterAction } from "components/primitives/Modal";
import React from "react";
import { Form } from "react-bootstrap";
import styled from "styled-components";

interface GroupConfigModelProps {
  isOpen: boolean;
  onClose: () => void;
  words: string;
  onSave: (configName: string) => void;
}

export const GroupConfigModel: React.FC<GroupConfigModelProps> = ({
  isOpen,
  onClose,
  words,
  onSave,
}) => {
  const [name, setName] = React.useState(words);

  const handleSave = () => {
    onSave(name); // Pass full configuration data
    onClose();
  };

  const footerActions: ModalFooterAction[] = [
    {
      key: "cancel",
      textBtn: "Cancel",
      color: "var(--danger)",
      action: onClose,
    },
    {
      key: "save",
      textBtn: "Save",
      color: "var(--primary)",
      action: handleSave,
      disabled: !name,
    },
  ];
  return (
    <Modal isOpen={isOpen} header="Save Group Configuration" footerActions={footerActions}>
      <Form.Group>
        <Label>Configuration Name</Label>
        <Form.Control
          type="text"
          maxLength={25}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Form.Group>
    </Modal>
  );
};

const Label = styled.label`
  font-weight: bold;
  display: block;
  margin-bottom: 8px;
`;
